export const supportKeys = {
  featureFlags: () => ['feature-flag-management'],
}
